// *****************************************************************************
// *** Global error class for all auth errors

import { FantazFailure } from '@fantaz/shared/data-access/models';

// *****************************************************************************
export class FzAuthFailure extends FantazFailure {}

/**
 * Error for when an internal error occurs.
 */
export class AuthUnknownFailure extends FzAuthFailure {
  constructor(reason: string) {
    super(
      'AuthUnknownFailure',
      'AUTH-1000',
      new Error(`Internal error occurred: ${reason}`),
    );
  }
}

export class FzAuthMaxAttemptsFailure extends FzAuthFailure {
  constructor() {
    super(
      'FzAuthMaxAttemptsFailure',
      'AUTH-3000',
      new Error(
        `Maximum number of sign-in attempts reached. Please wait a few minutes before trying again.`,
      ),
    );
  }
}

/**
 * Error for when a username is already taken.
 */
export class FzAuthUsernameExistFailure extends FzAuthFailure {
  constructor() {
    super(
      'FzAuthUsernameExistFailure',
      'AUTH-1001',
      new Error('Username already exists'),
    );
  }
}

export class FzAuthPhoneTypeInvalidFailure extends FzAuthFailure {
  constructor() {
    super(
      'FzAuthPhoneTypeInvalidFailure',
      'AUTH-1002',
      new Error('Phone number is invalid'),
    );
  }
}

export class AuthInvalidCredentialsFailure extends FzAuthFailure {
  constructor() {
    super(
      'AuthInvalidCredentialsFailure',
      'AUTH-1003',
      new Error('Incorrect username or password.'),
    );
  }
}

/**
 * Group all error classes for auth failures.
 */
export class FzAuthFailures {
  static readonly internal = (reason: string) => new AuthUnknownFailure(reason);
  static readonly usernameExist = () => new FzAuthUsernameExistFailure();
  static readonly phoneTypeInvalid = () => new FzAuthPhoneTypeInvalidFailure();
  static readonly invalidCredentials = () =>
    new AuthInvalidCredentialsFailure();
  static readonly maxAttempts = () => new FzAuthMaxAttemptsFailure();
}
